import React from 'react';
import ReactDOM from 'react-dom';
// import * as Sentry from '@sentry/browser';
// import './tailwind.output.css';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

//Sentry.init({ dsn: 'https://1c0d71cad49545d0900f0aea0fec5a61@o394245.ingest.sentry.io/5244129' });

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
